import { Component, Input } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-icon-button',
    template: `
    <a
      routerLink=""
      class="tw-inline-block md:tw-hidden tw-font-bold"
      [class.disabled]="disabled"
      [attr.disabled]="disabled ? '' : null"
      [attr.aria-label]="(ariaLabelText | translation: translationRequest) + (ariaLabelTextNoTranslation ? ' ' + ariaLabelTextNoTranslation : '')"
    >
      {{ label | translation: translationRequest }}
    </a>

    <span
      class="tw-cursor-pointer tw-hidden md:tw-inline-block tw-pt-1.5"
      [class.disabled]="disabled"
      [style.pointer-events]="disabled ? 'none' : 'auto'"
    >
      <mat-icon
        [style.width]="size + 'px'"
        [style.height]="size + 'px'"
        [style.font-size]="size + 'px'"
        [style.color]="disabled ? 'var(--color-disabled, #ccc)' : color"
        >{{ icon }}</mat-icon
      >
    </span>
  `,
    styles: [
        `
      .disabled {
        opacity: 0.6;
        cursor: not-allowed !important;
      }
    `,
    ],
    standalone: false
})
export class IconButtonComponent {
  @Input()
  icon: string;

  @Input()
  label: string;

  @Input()
  ariaLabelText: string = 'Actions Menu';

  @Input()
  ariaLabelTextNoTranslation: string = '';

  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	  });

  /**
   * Size of icon in pixels
   */
  @Input()
  size: number = 26;

  @Input()
  color: string = 'var(--sed-dynamic-black-color)';

  @Input()
  disabled: boolean = false;
}
